module.exports = __webpack_public_path__ + "img/image 18.99819254.png";